import {Radio, Loader2} from 'lucide-react'
import {Badge} from '@/components/ui/badge'
import {PulseDot} from '@/components/shared/PulseDot'

/* eslint-disable i18next/no-literal-string -- state identifiers, not user-visible strings */
export const ConnectionState = {
    CONNECTED: 'connected',
    ERROR: 'error',
    CONNECTING: 'connecting',
} as const
/* eslint-enable i18next/no-literal-string */
export type ConnectionState = typeof ConnectionState[keyof typeof ConnectionState]

interface ConnectionStatusBadgeProps {
    state: ConnectionState
    label: string
    'data-testid'?: string
}

/**
 * Badge variants tuned for SSE / realtime connection status: coloured outline
 * Badge with either a pulsing success dot, a warning icon, or a loading spinner.
 */
export function ConnectionStatusBadge({state, label, 'data-testid': testId}: ConnectionStatusBadgeProps) {
    if (state === ConnectionState.CONNECTED) {
        return (
            <Badge variant="outline" className="gap-1.5" data-testid={testId} data-state={state}>
                <PulseDot tone="success"/>
                <span className="text-status-success">{label}</span>
            </Badge>
        )
    }
    if (state === ConnectionState.ERROR) {
        return (
            <Badge variant="outline" className="gap-1.5" data-testid={testId} data-state={state}>
                <Radio className="h-3 w-3"/>
                <span className="text-status-warning">{label}</span>
            </Badge>
        )
    }
    return (
        <Badge variant="outline" className="gap-1.5" data-testid={testId} data-state={state}>
            <Loader2 className="animate-spin w-3 h-3"/>
            <span className="text-muted-foreground">{label}</span>
        </Badge>
    )
}
